import { useParams } from "react-router-dom";

const ReturnReplace = () => {
  const { orderId } = useParams();
  return <div>Tracking info for Order {orderId}</div>;
};

export default ReturnReplace;
